interface NavigationResourceProperty {
  propertyTypeId: number;
  valueBoolean?: boolean;
  valueNumber?: number;
  valueDecimal?: number;
  valueText?: unknown;
  valueChoices: { value: unknown; imageUrl: string }[];
  valueHTMLContent?: unknown;
  file?: string;
}

export function getNavigationResourcePropertyValue(property: NavigationResourceProperty) {
  switch (property.propertyTypeId) {
    case 1: {
      return {
        value: property.valueBoolean,
        imageUrl: property.file,
      };
    }
    case 2: {
      return {
        value: property.valueNumber,
        imageUrl: property.file,
      };
    }
    case 3: {
      return {
        value: property.valueDecimal,
        imageUrl: property.file,
      };
    }
    case 4: {
      return {
        value: property.valueText,
        imageUrl: property.file,
      };
    }
    case 5: {
      return property.valueChoices.map((choice) => ({
        title: choice.value,
        imageUrl: choice.imageUrl,
      }));
    }
    case 6: {
      return {
        value: property.valueHTMLContent,
        imageUrl: property.file,
      };
    }
    default:
      return null;
  }
}

export function hasResourcePropertyValue(value: unknown): boolean {
  if (value === null || value === undefined || value === '') {
    return false;
  }

  if (Array.isArray(value)) {
    return value.length > 0;
  }

  if (typeof value === 'object') {
    return Object.values(value).some((localizedValue) => hasResourcePropertyValue(localizedValue));
  }

  return true;
}

export function hasVisibleResourcePropertyValue(visible: boolean, value: unknown): boolean {
  return visible && hasResourcePropertyValue(value);
}
